import { useMemo, memo } from 'react';
import { DataTable } from '../../../components/ui/data-table';
import { ColumnDef } from '@tanstack/react-table';
import { useUploadContext } from './upload-provider';
import type { FileStatusItem } from '../types';

const STATUS_COLORS = {
  success: 'text-green-600',
  error: 'text-red-600',
  processing: 'text-yellow-600',
} as const;

const STATUS_LABELS = {
  success: 'Sucesso',
  error: 'Erro',
  processing: 'Processando',
} as const;

const columns: ColumnDef<FileStatusItem>[] = [
  {
    accessorKey: 'id',
    header: 'ID',
    enableHiding: true,
  },
  {
    accessorKey: 'created_by',
    header: 'Usuário',
  },
  {
    accessorKey: 'size',
    header: 'Tamanho',
    cell: ({ row }) => {
      const bytes = row.getValue('size') as number;
      const mb = (bytes / (1024 * 1024)).toFixed(2);
      return `${mb} MB`;
    },
  },
  {
    accessorKey: 'real_name',
    header: 'Nome do arquivo',
  },
  {
    accessorKey: 'doc_type',
    header: 'Tipo do documento',
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const status = row.getValue('status') as keyof typeof STATUS_COLORS;
      const colorClass = STATUS_COLORS[status] || 'text-gray-600';
      const label = STATUS_LABELS[status] || status;

      return <span className={colorClass}>{label}</span>;
    },
  },
  {
    accessorKey: 'error',
    header: 'Mensagem',
    cell: ({ row }) => {
      const error = row.getValue('error') as string;
      if (!error) {
        return <span className="text-muted-foreground">-</span>;
      }
      return <span className="text-destructive">{error}</span>;
    },
  },
];

const FileStatusTableInner = memo(function FileStatusTable() {
  const { state } = useUploadContext();
  const { files } = state;

  const memoizedColumns = useMemo(() => columns, []);

  if (files.length === 0) {
    return null;
  }

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Status dos Arquivos</h2>
      <DataTable
        columns={memoizedColumns}
        data={files}
        searchableColumns={['real_name']}
        searchPlaceholder="Buscar por nome do arquivo..."
      />
    </div>
  );
});

export { FileStatusTableInner as FileStatusTable };
